import { render, staticRenderFns } from "./table-component.vue?vue&type=template&id=6e2619cb&scoped=true&"
import script from "./table-component.vue?vue&type=script&lang=js&"
export * from "./table-component.vue?vue&type=script&lang=js&"
import style0 from "./table-component.vue?vue&type=style&index=0&id=6e2619cb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2619cb",
  null
  
)

export default component.exports